export const profileRequiredFields = [
  'email',
  'firstName',
  'lastName',
  'birthdate',
  'gender',
  'raceEthnicHeritage',
  'workStatus',
  'annualHouseholdIncome',
  'state',
  'country',
  'jobCategories',
  'paymentMethod',
  'paypalAccount',
  'smartphone',
  'computer',
  'tablet',
  'currentPosition',
  'recruitingProgram',
  'educationLevel',
  'languages',
];
